// Angular Modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorStateMatcher, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
const angularModules = [
  CommonModule, FormsModule, ReactiveFormsModule,
  MatInputModule, MatFormFieldModule, MatDatepickerModule, MatNativeDateModule
];
const exportedAngularModules = [
  FormsModule, ReactiveFormsModule
]

// Dropdown Components
import { CustomErrorStateMatcher } from '../form-field';
import { DatepickerComponent } from './datepicker.component';
const exportComponents = [ DatepickerComponent ];

@NgModule({
  declarations: [...exportComponents],
  imports: [
    ...angularModules
  ],
  exports: [
    ...exportedAngularModules,
    ...exportComponents
  ],
  providers: [
    {provide: ErrorStateMatcher, useClass: CustomErrorStateMatcher }
  ]
})
export class TriggeredDatepickerModule { }
